<app-ice-select-box
  type="checkbox"
  [checkboxTestId]="groupId()"
  [control]="selected"
  [infoText]="service().longDescription"
  [label]="service().description"
  [readonly]="activeSims().length > 0"
  [reserveSpaceForInfoText]="true"
  [value]="groupId()"
/>
@if (isGroupSelected) {
  <div class="sim-group-body">
    @for (activeSim of activeSims(); track activeSim.service.instanceId) {
      <div class="sim-row" [formGroup]="activeSim.form">
        <app-additional-sim
          [instanceId]="activeSim.service.instanceId"
          [label]="activeSim.label"
          [service]="activeSim.service"
        />
      </div>
    }
    @for (view of rowViews(); track view.row.instanceId) {
      <div class="sim-row" [formGroup]="view.row.form">
        <app-additional-sim
          [instanceId]="view.row.instanceId"
          [label]="view.label"
          [readonly]="true"
          [service]="service()"
        />
        <app-ice-icon-button
          class="sim-row-remove"
          size="1.5rem"
          [ariaLabel]="view.removeLabel"
          [iconName]="IconNames.ice_trash"
          [testId]="'remove-sim-' + view.row.instanceId"
          (clicked)="onRemove(view.row)"
        />
      </div>
    }
    @if (canAdd()) {
      <div class="add-sim">
        <button
          class="add-sim-button"
          type="button"
          [attr.aria-label]="addLabel()"
          [attr.data-testid]="'add-sim-' + service().productId"
          (click)="add.emit()"
        >
          <mat-icon [svgIcon]="IconNames.ice_add" />
        </button>
      </div>
    }
  </div>
}
